import React from 'react';
import { RatingLayout } from '../rating.layout';
import { PagePath } from '../../../../navigation/navigation.enums';

export function RatingCareerPathsPage(): JSX.Element {
  return <RatingLayout path={PagePath.analysisRateYourSkillsRating} title="Career path skills" type="career-path" />;
}
